import svAccessLogs from './resources/sv/access-logs.json';
import svAdminUsers from './resources/sv/admin-users.json';
import svAll from './resources/sv/all.json';
import svArea from './resources/sv/area.json';
import svBlock from './resources/sv/block.json';
import svBookmarks from './resources/sv/bookmarks.json';
import svComments from './resources/sv/comments.json';
import svCommon from './resources/sv/common.json';
import svDashboard from './resources/sv/dashboard.json';
import svDc from './resources/sv/dc.json';
import svDocEditor from './resources/sv/doc-editor.json';
import svDocEditorLink from './resources/sv/doc-editor-link.json';
import svDocument from './resources/sv/document.json';
import svDocumentPermissions from './resources/sv/document-permissions.json';
import svDropdown from './resources/sv/dropdown.json';
import svEditor from './resources/sv/editor.json';
import svFilezone from './resources/sv/filezone.json';
import svGeneric from './resources/sv/generic.json';
import svGraphicalVariable from './resources/sv/graphical-variable.json';
import svImageQueries from './resources/sv/image-queries.json';
import svImageimport from './resources/sv/imageimport.json';
import svImport from './resources/sv/import.json';
import svInfoblob from './resources/sv/infoblob.json';
import svLabel from './resources/sv/label.json';
import svLabels from './resources/sv/labels.json';
import svLang from './resources/sv/lang.json';
import svLayoutPicker from './resources/sv/layout-picker.json';
import svLists from './resources/sv/lists.json';
import svMenu from './resources/sv/menu.json';
import svMyProfile from './resources/sv/my-profile.json';
import svNavbar from './resources/sv/navbar.json';
import svNotifications from './resources/sv/notifications.json';
import svOrganisations from './resources/sv/organisations.json';
import svOrganizationMenu from './resources/sv/organization-menu.json';
import svOverview from './resources/sv/overview.json';
import svPage from './resources/sv/page.json';
import svPictures from './resources/sv/pictures.json';
import svProjectDetails from './resources/sv/project-details.json';
import svProjectList from './resources/sv/project-list.json';
import svProjectSettings from './resources/sv/project-settings.json';
import svReferenceData from './resources/sv/reference-data.json';
import svReferenceTable from './resources/sv/reference-table.json';
import svRequest from './resources/sv/request.json';
import svReset from './resources/sv/reset.json';
import svRevision from './resources/sv/revision.json';
import svRollForward from './resources/sv/roll-forward.json';
import svSectionPermissions from './resources/sv/section-permissions.json';
import svServer from './resources/sv/server.json';
import svStyledParagraph from './resources/sv/styled-paragraph.json';
import svStyledparagraph from './resources/sv/styledparagraph.json';
import svSubToolbar from './resources/sv/sub-toolbar.json';
import svSupport from './resources/sv/support.json';
import svTable from './resources/sv/table.json';
import svTableImport from './resources/sv/table-import.json';
import svTag from './resources/sv/tag.json';
import svTaxonomy from './resources/sv/taxonomy.json';
import svTemplate from './resources/sv/template.json';
import svTemplateEditor from './resources/sv/template-editor.json';
import svTemplates from './resources/sv/templates.json';
import svTheme from './resources/sv/theme.json';
import svToc from './resources/sv/toc.json';
import svToolbar from './resources/sv/toolbar.json';
import svToolbarCss from './resources/sv/toolbar-css.json';
import svUsers from './resources/sv/users.json';
import svXliffPreview from './resources/sv/xliff-preview.json';

import enAccessLogs from './resources/en/access-logs.json';
import enAdminUsers from './resources/en/admin-users.json';
import enAll from './resources/en/all.json';
import enArea from './resources/en/area.json';
import enBlock from './resources/en/block.json';
import enBookmarks from './resources/en/bookmarks.json';
import enComments from './resources/en/comments.json';
import enCommon from './resources/en/common.json';
import enDashboard from './resources/en/dashboard.json';
import enDc from './resources/en/dc.json';
import enDocEditor from './resources/en/doc-editor.json';
import enDocEditorLink from './resources/en/doc-editor-link.json';
import enDocument from './resources/en/document.json';
import enDocumentPermissions from './resources/en/document-permissions.json';
import enDropdown from './resources/en/dropdown.json';
import enEditor from './resources/en/editor.json';
import enFilezone from './resources/en/filezone.json';
import enGeneric from './resources/en/generic.json';
import enGraphicalVariable from './resources/en/graphical-variable.json';
import enImageQueries from './resources/en/image-queries.json';
import enImageimport from './resources/en/imageimport.json';
import enImport from './resources/en/import.json';
import enInfoblob from './resources/en/infoblob.json';
import enLabel from './resources/en/label.json';
import enLabels from './resources/en/labels.json';
import enLang from './resources/en/lang.json';
import enLayoutPicker from './resources/en/layout-picker.json';
import enLists from './resources/en/lists.json';
import enMenu from './resources/en/menu.json';
import enMyProfile from './resources/en/my-profile.json';
import enNavbar from './resources/en/navbar.json';
import enNotifications from './resources/en/notifications.json';
import enOrganisations from './resources/en/organisations.json';
import enOrganizationMenu from './resources/en/organization-menu.json';
import enOverview from './resources/en/overview.json';
import enPage from './resources/en/page.json';
import enPictures from './resources/en/pictures.json';
import enProjectDetails from './resources/en/project-details.json';
import enProjectList from './resources/en/project-list.json';
import enProjectSettings from './resources/en/project-settings.json';
import enReferenceData from './resources/en/reference-data.json';
import enReferenceTable from './resources/en/reference-table.json';
import enRequest from './resources/en/request.json';
import enReset from './resources/en/reset.json';
import enRevision from './resources/en/revision.json';
import enRollForward from './resources/en/roll-forward.json';
import enSectionPermissions from './resources/en/section-permissions.json';
import enServer from './resources/en/server.json';
import enStyledParagraph from './resources/en/styled-paragraph.json';
import enStyledparagraph from './resources/en/styledparagraph.json';
import enSubToolbar from './resources/en/sub-toolbar.json';
import enSupport from './resources/en/support.json';
import enTable from './resources/en/table.json';
import enTableImport from './resources/en/table-import.json';
import enTag from './resources/en/tag.json';
import enTaxonomy from './resources/en/taxonomy.json';
import enTemplate from './resources/en/template.json';
import enTemplateEditor from './resources/en/template-editor.json';
import enTemplates from './resources/en/templates.json';
import enTheme from './resources/en/theme.json';
import enToc from './resources/en/toc.json';
import enToolbar from './resources/en/toolbar.json';
import enToolbarCss from './resources/en/toolbar-css.json';
import enUsers from './resources/en/users.json';
import enXliffPreview from './resources/en/xliff-preview.json';

export const resources = {
  sv: {
    'access-logs': svAccessLogs,
    'admin-users': svAdminUsers,
    all: svAll,
    area: svArea,
    block: svBlock,
    bookmarks: svBookmarks,
    comments: svComments,
    common: svCommon,
    dashboard: svDashboard,
    dc: svDc,
    'doc-editor': svDocEditor,
    'doc-editor-link': svDocEditorLink,
    document: svDocument,
    'document-permissions': svDocumentPermissions,
    dropdown: svDropdown,
    editor: svEditor,
    filezone: svFilezone,
    generic: svGeneric,
    'graphical-variable': svGraphicalVariable,
    'image-queries': svImageQueries,
    imageimport: svImageimport,
    import: svImport,
    infoblob: svInfoblob,
    label: svLabel,
    labels: svLabels,
    lang: svLang,
    'layout-picker': svLayoutPicker,
    lists: svLists,
    menu: svMenu,
    'my-profile': svMyProfile,
    navbar: svNavbar,
    notifications: svNotifications,
    organisations: svOrganisations,
    'organization-menu': svOrganizationMenu,
    overview: svOverview,
    page: svPage,
    pictures: svPictures,
    'project-details': svProjectDetails,
    'project-list': svProjectList,
    'project-settings': svProjectSettings,
    'reference-data': svReferenceData,
    'reference-table': svReferenceTable,
    request: svRequest,
    reset: svReset,
    revision: svRevision,
    'roll-forward': svRollForward,
    'section-permissions': svSectionPermissions,
    server: svServer,
    'styled-paragraph': svStyledParagraph,
    styledparagraph: svStyledparagraph,
    'sub-toolbar': svSubToolbar,
    support: svSupport,
    table: svTable,
    'table-import': svTableImport,
    tag: svTag,
    taxonomy: svTaxonomy,
    template: svTemplate,
    'template-editor': svTemplateEditor,
    templates: svTemplates,
    theme: svTheme,
    toc: svToc,
    toolbar: svToolbar,
    'toolbar-css': svToolbarCss,
    users: svUsers,
    'xliff-preview': svXliffPreview,
  },
  en: {
    'access-logs': enAccessLogs,
    'admin-users': enAdminUsers,
    all: enAll,
    area: enArea,
    block: enBlock,
    bookmarks: enBookmarks,
    comments: enComments,
    common: enCommon,
    dashboard: enDashboard,
    dc: enDc,
    'doc-editor': enDocEditor,
    'doc-editor-link': enDocEditorLink,
    document: enDocument,
    'document-permissions': enDocumentPermissions,
    dropdown: enDropdown,
    editor: enEditor,
    filezone: enFilezone,
    generic: enGeneric,
    'graphical-variable': enGraphicalVariable,
    'image-queries': enImageQueries,
    imageimport: enImageimport,
    import: enImport,
    infoblob: enInfoblob,
    label: enLabel,
    labels: enLabels,
    lang: enLang,
    'layout-picker': enLayoutPicker,
    lists: enLists,
    menu: enMenu,
    'my-profile': enMyProfile,
    navbar: enNavbar,
    notifications: enNotifications,
    organisations: enOrganisations,
    'organization-menu': enOrganizationMenu,
    overview: enOverview,
    page: enPage,
    pictures: enPictures,
    'project-details': enProjectDetails,
    'project-list': enProjectList,
    'project-settings': enProjectSettings,
    'reference-data': enReferenceData,
    'reference-table': enReferenceTable,
    request: enRequest,
    reset: enReset,
    revision: enRevision,
    'roll-forward': enRollForward,
    'section-permissions': enSectionPermissions,
    server: enServer,
    'styled-paragraph': enStyledParagraph,
    styledparagraph: enStyledparagraph,
    'sub-toolbar': enSubToolbar,
    support: enSupport,
    table: enTable,
    'table-import': enTableImport,
    tag: enTag,
    taxonomy: enTaxonomy,
    template: enTemplate,
    'template-editor': enTemplateEditor,
    templates: enTemplates,
    theme: enTheme,
    toc: enToc,
    toolbar: enToolbar,
    'toolbar-css': enToolbarCss,
    users: enUsers,
    'xliff-preview': enXliffPreview,
  },
} as const;

export const namespaces = Object.keys(resources.sv) as (keyof typeof resources.sv)[];
export const supportedLngs = Object.keys(resources) as (keyof typeof resources)[];
